var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagesearchRoller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_40199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_40199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 23H11C10.7167 23 10.4792 22.9042 10.2875 22.7125C10.0958 22.5208 10 22.2833 10 22V16C10 15.7167 10.0958 15.4792 10.2875 15.2875C10.4792 15.0958 10.7167 15 11 15H12V12H4C3.45 12 2.97917 11.8042 2.5875 11.4125C2.19583 11.0208 2 10.55 2 10V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H6V3C6 2.71667 6.09583 2.47917 6.2875 2.2875C6.47917 2.09583 6.71667 2 7 2H19C19.2833 2 19.5208 2.09583 19.7125 2.2875C19.9042 2.47917 20 2.71667 20 3V7C20 7.28333 19.9042 7.52083 19.7125 7.7125C19.5208 7.90417 19.2833 8 19 8H7C6.71667 8 6.47917 7.90417 6.2875 7.7125C6.09583 7.52083 6 7.28333 6 7V6H4V10H12C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12V15H15C15.2833 15 15.5208 15.0958 15.7125 15.2875C15.9042 15.4792 16 15.7167 16 16V22C16 22.2833 15.9042 22.5208 15.7125 22.7125C15.5208 22.9042 15.2833 23 15 23ZM12 21H14V17H12V21ZM8 6H18V4H8V6Z",
    fill: "#7F599D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesearchRoller);
export default __webpack_public_path__ + "static/media/imagesearch_roller.c3c21faa2e7faf1e833e31ff9ae3f4a3.svg";
export { ForwardRef as ReactComponent };